import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { creatorListingsPath, serviceCreatorStagePath } from "@travily/routes";
import type ListingsCreatorPriceType from "@travily/types/pages/ListingsCreatorPriceType";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ServicePriceTypeStepView } from "./show.view";

type PageProps = ListingsCreatorPriceType;

type FormData = {
  price_type: "free" | "paid";
};

// First pricing stage: a clean free-or-paid fork with no price field. Choosing
// "Paid" routes on to the selling-country step (first time) or the price.
const ServicePriceTypeStep = ({ listing_id, stage_index, stage_order, price_type }: PageProps) => {
  const { form, currentStage, totalStages, onBack, onPrimary, primaryPending } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => serviceCreatorStagePath(listing_id, stage),
      entryUrl: creatorListingsPath(),
    },
    stageName: "price_type",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { price_type: price_type === "paid" ? "paid" : "free" },
  });

  const topBarActions = useCreatorTopBarActions({ saveHref: creatorListingsPath() });

  return (
    <>
      <Head title={t("web.services.creator.steps.price_type.show.meta_title")}>
        <meta name="description" content={t("web.services.creator.steps.price_type.show.meta_description")} />
      </Head>
      <ServicePriceTypeStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        priceType={form.data.price_type}
        onPriceTypeChange={(value) => form.setData("price_type", value === "paid" ? "paid" : "free")}
      />
    </>
  );
};

export default ServicePriceTypeStep;
